import { useQuery } from '@tanstack/react-query';
import type { Site } from '@inboundhost/shared';
import { api } from '../lib/api';

export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: () => api<{ sites: Site[] }>('/sites'),
  });
}

export function useSite(siteId: string | undefined) {
  return useQuery({
    queryKey: ['sites', siteId],
    queryFn: () => api<{ site: Site }>(`/sites/${siteId}`),
    enabled: !!siteId,
  });
}
